import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  margin: 0,
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
}));

const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: 0,
  color: theme.palette.grey[500],
}));

const DialogTitle = ({ children, onClose, align, isShowClose, ...other }) => {
  return (
    <StyledDialogTitle {...other}>
      <Box>
        <Typography variant="h6" align={align}>
          {children}
        </Typography>
        {onClose && isShowClose ? (
          <StyledCloseButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </StyledCloseButton>
        ) : null}
      </Box>
    </StyledDialogTitle>
  );
};

const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1),
}));

function AxlDialog({
  isOpen,
  childrenTitle,
  childrenAction,
  children,
  handleClose,
  maxWidth = 'md',
  alignTitle = 'inherit',
  DialogContentProps,
  datatestid,
  dividers = true,
  isShowClose = true,
  style,
}) {
  return (
    <Dialog onClose={handleClose} open={isOpen} fullWidth maxWidth={maxWidth} style={{ fontFamily: 'AvenirNext', ...style }}>
      <div data-testid={datatestid}>
        <DialogTitle onClose={handleClose} align={alignTitle} isShowClose={isShowClose}>
          {childrenTitle}
        </DialogTitle>
        <DialogContent dividers={dividers} {...DialogContentProps}>
          {children}
        </DialogContent>
        {childrenAction && <DialogActions>{childrenAction}</DialogActions>}
      </div>
    </Dialog>
  );
}

export default AxlDialog;
